import TableModule from "components/Modules/Collections/TableModule"
import { getDataFromFirestoreCollection } from "helpers/Firestore"

const CityCampaignTable = () => {
  const getColorForCampaign = val => {
    const now = new Date()

    const startTime = new Date(val.StartTime)
    const endTime = new Date(val.EndTime)

    if (now.getTime() < startTime.getTime()) return "#ee7454"

    if (now.getTime() > endTime.getTime()) return "#8173ab"

    return "#23d2ae"
  }

  return (
    <TableModule
      getData={async ({ firebaseUID }) => {
        console.log("firebaseUID", firebaseUID)
        const data = await getDataFromFirestoreCollection({
          path: `Offers/Campaigns/DataBase`,
          where: [
            {
              key: "City_ID",
              operation: "==",
              value: firebaseUID,
            },
          ],
          sortBy: { key: "DateOfEntry" },
          timestampKeys: ["DateOfEntry"],
        })

        console.log("data", data)

        return data.map(d => ({ ...d, Color: getColorForCampaign(d) }))
      }}
      openButtonIndex={1}
      noInitialSort
      columns={[
        {
          key: "Color",
          label: "",
          styling: { Type: "Color point" },
        },
        { key: "Title", label: "Title" },
      ]}
      searchKey={"Title"}
    />
  )
}

export default CityCampaignTable
